import { ID } from "src/libs/interfaces/layouts"
import { ILanding, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import resetPosition from "./resetPosition"

export default function resetPositionSelected() {
    const currentLanding: ILanding                  = useLandingStore.getState().currentLanding
        const selectedType: SELECT_TYPE             = useLandingStore.getState().selectedType
        const selectedLayer : ID                    = useLandingStore.getState().selectedLayer
        const selectedMeat : ID                     = useLandingStore.getState().selectedMeat
        const selectedFloat : ID                    = useLandingStore.getState().selectedFloat
        const section: ILandingSection | undefined  = currentLanding.sections.find(section => section.id === selectedLayer)
        if(!section) return  
         
        console.log( selectedType, "selectedFloat:", selectedFloat, "selectedMeat:", selectedMeat )
        
        switch( selectedType ) {
            case SELECT_TYPE.TITLE: 
                resetPosition( section.id )
                break
            case SELECT_TYPE.FLOAT:
                resetPosition( selectedFloat )
                break
            case SELECT_TYPE.CONTENT:
                resetPosition( selectedMeat )
                break
            default:
                return
        }
}